<template>
  <canvas ref="chart"></canvas>
</template>

<script>
import { Chart } from "chart.js";

export default {
  name: "HorizontalBarChart",
  props: {
    chartData: {
      type: Object,
      default: () => ({ labels: [], values: [], total: 0 }),
    },
    showPercentage: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "#2e4664",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      if (!this.chartData || !this.chartData.labels) return;

      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.chart.getContext("2d");
      const total = this.chartData.total || 1;
      const showPct = this.showPercentage;

      const datalabelsPlugin = {
        id: 'horizontalDatalabels',
        afterDatasetsDraw(chart) {
          const { ctx } = chart;
          const dataset = chart.data.datasets[0];
          const meta = chart.getDatasetMeta(0);

          meta.data.forEach((bar, index) => {
            const value = dataset.data[index];
            const pct = ((value / total) * 100).toFixed(0);

            ctx.save();
            ctx.fillStyle = '#333';
            ctx.font = 'bold 12px sans-serif';
            ctx.textAlign = 'left';
            ctx.textBaseline = 'middle';

            const label = showPct ? `${value} (${pct}%)` : `${value}`;
            ctx.fillText(label, bar.x + 8, bar.y);
            ctx.restore();
          });
        },
      };

      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.chartData.labels,
          datasets: [
            {
              data: this.chartData.values,
              backgroundColor: this.color,
              borderRadius: 4,
            },
          ],
        },
        options: {
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              right: 80,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const value = context.raw;
                  const pct = ((value / total) * 100).toFixed(1);
                  return `${value} médicos (${pct}%)`;
                },
              },
            },
          },
          scales: {
            x: {
              beginAtZero: true,
              grid: {
                display: true,
              },
            },
            y: {
              grid: {
                display: false,
              },
            },
          },
        },
        plugins: [datalabelsPlugin],
      });
    },
  },
};
</script>
